import { render, staticRenderFns } from "./ViewMigration.vue?vue&type=template&id=3590325f&"
import script from "./ViewMigration.vue?vue&type=script&lang=ts&"
export * from "./ViewMigration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports